export default function defaultErrorHandler(error) {
    throw error;
}
